import { AiService, FindingAiService } from '../api/agentStep.model';

export const RSA_DEMO_AI_SERVICES: string[] = [AiService.claudeCode, AiService.homegrown];

export const RSA_DEMO_FINDING_AI_SERVICES: string[] = [FindingAiService.claudeCode, FindingAiService.homegrown];
